import { useContext } from "react";
import HeaderComponent from "../components/header/Header";
import SidebarComponent from "../components/sidebar/Sidebar";
import { IAppContextState, AppContext } from "../App";
import FooterComponent from "../components/footer/Footer";

function MainLayout({ children }: any) {
  const { isCollapsedSidebarState } = useContext<IAppContextState | any>(
    AppContext,
  );
  const [isCollapsedSidebar] = isCollapsedSidebarState;
  return (
    <>
      <div className="flex">
        <SidebarComponent />
        <div
          className={`${
            isCollapsedSidebar ? "md:ps-0" : "md:ps-[16rem]"
          } w-[100%] transition-all`}
        >
          <HeaderComponent />
          <div className="h-[calc(100vh-108px)] overflow-y-auto bg-gray-800 text-gray-300 lg:px-16 md:px-8 sm:px-4 px-2">
            {children}
          </div>
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default MainLayout;
